<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>

      <v-flex xs12>
        <v-card tile flat>
          <v-toolbar dense flat>
            <v-btn icon>
              <v-icon color="blue">{{section.icon || 'apps'}}</v-icon>
            </v-btn>
            <v-toolbar-title class="mx-0 px-0 subheading v-subheader">
              {{section.name}}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider/>
          <v-card-text>
            <ul
              class="section-list"
              v-if="section.items && section.items.length > 0">
              <li v-for="a in section.items" :key="a.dbid">
                <router-link :to="`/${section.identifier}/${a.dbid}`" target="_blank" v-html="a.title"/>
                <span v-html="a.pubDate"></span>
              </li>
            </ul>
            <div v-else>
              [无内容]
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <!--PC端-->
      <v-flex
        xs12
        class="text-xs-center hidden-sm-and-down"
        v-if="section.items && section.items.length > 0">
        <v-pagination
          v-model="page"
          :length="length"
          :total-visible="9"
          color="blue"
          circle
        />
      </v-flex>
      <!--移动端-->
      <v-flex
        xs12
        class="text-xs-center hidden-md-and-up"
        v-if="section.items && section.items.length > 0">
        <v-pagination
          v-model="page"
          :length="length"
          small
          :total-visible="4"
          color="blue"
          circle
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: "Section",
    data() {
      return {
        section: {},
        page: 1,
        length: 5
      }
    },
    beforeRouteEnter(to, from, next) {
      const uri = `/api/site/section/${to.params.sectionId}`;
      Vue.axios.get(uri, {params: to.query}).then(
        rsp => next(vm => {
          vm.section = rsp.data;
          vm.page = vm.section.page + 1;
          vm.length = vm.section.numberOfPages;
        })
      )
    },
    // 路由改变前，组件就已经渲染完了
    // 逻辑稍稍不同
    beforeRouteUpdate(to, from, next) {
      const uri = `/api/site/section/${to.params.sectionId}`;
      Vue.axios.get(uri, {params: to.query}).then(
        rsp => {
          this.section = rsp.data;
          this.page = this.section.page + 1;
          this.length = this.section.numberOfPages;

          next()
        }
      );
    },
    watch: {
      page(nv, ov) {
        this.$router.push(
          {
            path: `/${this.$route.params.sectionId}`,
            query: {
              page: nv - 1
            }
          }
        )
      }
    }
  }
</script>

<style scoped>
  div.card__text {
    padding: 5px 20px;
  }

  ol, ul {
    list-style: none;
  }

  li {
    display: flex;
    flex-direction: row;
    text-align: -webkit-match-parent;
    margin-bottom: .333em;
    border-bottom: 1px dashed lightgray;
    height: 1.75em;
  }

  li:last-child {
    border-bottom: none;
  }

  /* 对 Edge 无效*/
  /*li:before {*/
    /*font-family: 'Material Icons', monospace;*/
    /*content: "stop" !important;*/
    /*font-size: 9pt;*/
    /*color: lightgrey;*/
  /*}*/

  li > a {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    color: #333333;
  }

  li > a:visited {
    color: #333333;
  }

  li > a:hover {
    color: #1976d2;
  }

  li > span {
    width: 8em;
    text-align: right;
  }


</style>

